"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifyUserquerySchema = exports.notifyUserSchema = exports.appMetadataSchema = void 0;
const yup = __importStar(require("yup"));
exports.appMetadataSchema = yup.object().shape({
    account_v2: yup.string().required(),
    isAdmin: yup.boolean().required(),
    tenant: yup.string().required()
});
exports.notifyUserSchema = yup.object().shape({
    email: yup.string().email('Invalid email format').required().max(320).label('Email'),
    phone_number: yup.string(),
    user_metadata: yup.object(),
    blocked: yup.boolean(),
    email_verified: yup.boolean(),
    phone_verified: yup.boolean(),
    app_metadata: exports.appMetadataSchema,
    given_name: yup.string(),
    family_name: yup.string(),
    name: yup.string(),
    nickname: yup.string(),
    picture: yup.string().url('Invalid URL format'),
    user_id: yup.string(),
    connection: yup.string(),
    password: yup.string().min(8, 'Password must be at least 8 characters long'),
    verify_email: yup.boolean(),
    username: yup.string()
});
exports.notifyUserquerySchema = yup.object().shape({
    page: yup.number().min(0).default(0).optional(),
    pageSize: yup.number().min(1).max(100).default(10).optional(),
    search: yup.string().optional()
});
